// SPDX-License-Identifier: AGPL-3.0-or-later

import {makePersistent} from '@app/features/platform/utils/MobXPersistence';
import {makeAutoObservable} from 'mobx';

class LeaderboardsDiscoveryState {
	seen = false;
	hydrated = false;

	constructor() {
		makeAutoObservable(this, {}, {autoBind: true});
		void makePersistent(this, 'LeaderboardsDiscovery', ['seen']).then(this.markHydrated);
	}

	markSeen(): void {
		this.seen = true;
	}

	markHydrated(): void {
		this.hydrated = true;
	}
}

export default new LeaderboardsDiscoveryState();
